module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-5500-Classes-Active-0371cea984661cfaa78a384d44ea50f7.png";